import React, { useState, useContext, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { animated, useTransition } from "react-spring";
import ReactResizeDetector from "react-resize-detector";
import useMediaQuery from "../../hooks/media-match";
import Header from "./Header";
import County from "./County";
import Judge from "./Judge";
import { DataContext } from "../../context/DataContext";
import NoData from "./NoData";
import { PANEL_SIDEVIEW_BREAKPOINT } from "../../utils/constants";

const displayPanelView = ({
  panelDisplay,
  countyDisplay,
  setCountyDisplay,
}) => {
  const ENUM = {
    noData: <NoData />,
    county: (
      <County
        countyDisplay={countyDisplay}
        setCountyDisplay={setCountyDisplay}
      />
    ),
    judge: <Judge />,
  };
  return ENUM[panelDisplay];
};

const Panel = ({ showPanel }) => {
  const { selection, changeSelection, countyData, setPanelDims } = useContext(
    DataContext
  );
  const [panelDisplay, setPanelDisplay] = useState("county");
  const [countyDisplay, setCountyDisplay] = useState("overview");
  const handleClose = () => {
    changeSelection({ id: undefined, type: "", county: "", label: "" });
    setCountyDisplay("overview");
  };
  const { county } = selection;

  const handleBack = () => {
    setCountyDisplay("judges");
    changeSelection({ id: county, type: "county", county, label: county });
  };

  const lgScreen = useMediaQuery(PANEL_SIDEVIEW_BREAKPOINT);
  const transitions = useTransition(showPanel, null, {
    from: { slide: -100, opacity: 0 },
    enter: { slide: 0, opacity: 1 },
    leave: { slide: -100, opacity: 0 },
  });

  const elTest = useRef();
  useEffect(() => {
    if (selection.county) {
      const selectedCountyData = countyData.find((item) => item.id === county);
      const { noData } = selectedCountyData;
      if (noData) {
        setPanelDisplay("noData");
      } else {
        setPanelDisplay(selection.type);
      }
    }
  }, [selection, county, countyData]);

  return transitions.map(({ item, key, props }) => {
    const { slide, opacity } = props;
    let animStyles;

    if (lgScreen) {
      animStyles = {
        bottom: 0,
        right: slide.interpolate((slideVal) => `${slideVal}%`),
        opacity,
      };
    } else {
      animStyles = {
        bottom: slide.interpolate((slideVal) => `${slideVal}%`),
        right: 0,
        opacity,
      };
    }
    return (
      item && (
        <animated.div
          key={key}
          className="panel__container-outer"
          style={{
            ...animStyles,
          }}
        >
          <ReactResizeDetector
            handleWidth
            handleHeight
            refreshMode="debounce"
            refreshRate={500}
            onResize={(width, height) => setPanelDims({ width, height })}
          >
            {({ targetRef }) => (
              <div className="panel__container-inner" ref={targetRef}>
                <Header
                  label={county}
                  handleClose={handleClose}
                  handleBack={handleBack}
                  selectionType={selection.type}
                />
                <div className="panel__container-body" ref={elTest}>
                  {selection.id &&
                    displayPanelView({
                      panelDisplay,
                      countyDisplay,
                      setCountyDisplay,
                    })}
                </div>
              </div>
            )}
          </ReactResizeDetector>
        </animated.div>
      )
    );
  });
};

Panel.propTypes = {
  showPanel: PropTypes.bool.isRequired,
};

export default Panel;
